import * as React from "react";
import { useState, useEffect } from "react";
import {
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import Search from "../../../shared/components/Search";
import { getAllCategories } from "../../../services/category";

interface FilterItem {
  label: string;
  selected: boolean;
  _id: string;
}

interface FilterData {
  categories: FilterItem[];
}

interface Props {
  setProductList?: any;
  productList?: any;
  handleChangeActiveFilters?: any;
  setActiveFilters?: any;
  activeFilters?: any;
}
// const filterData: FilterData = {
//   categories: [
//     { label: "Header", selected: true },
//     { label: "Navigation", selected: false },
//     { label: "Contact", selected: true },
//     { label: "FAQ’s", selected: true },
//     { label: "Feature", selected: true },
//     { label: "How it works", selected: false },
//     { label: "Team", selected: false },
//     { label: "Profile", selected: true },
//     { label: "Testimonials", selected: true },
//     { label: "Pricing Table", selected: false },
//   ],
// };

const CategoryFiltersPage: React.FC<Props> = ({
  setProductList,
  productList,
  handleChangeActiveFilters,
  setActiveFilters,
  activeFilters,
}) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [search, setSearch] = useState("");
  const [isTitleSelected, setIsTitleSelected] = useState<boolean>(false);
  // const [selectedFilterData, setSelectedFilterData] = useState<FilterData>({
  //   ...filterData,
  // });
  const [selectedFilterData, setSelectedFilterData] = useState<FilterData>({
    categories: [],
  });
  const [filteredCategories, setFilteredCategories] = useState<FilterItem[]>(
    []
  );

  const updateTitleCheckboxState = (categories: FilterItem[]) => {
    const allSelected = categories.every((item) => item.selected);
    setIsTitleSelected(allSelected);
  };

  // Fetch categories from API
  const fetchCategories = async (filters?: any) => {
    setLoading(true);
    try {
      const res = await getAllCategories(filters);
      const categories = res.paginatedConstantValues.map((category: any) => ({
        label: category.value,
        // selected: category.isActive,
        // selected: true,
        selected: false,
        _id: category._id,
      }));
      setSelectedFilterData({ categories });
      setFilteredCategories(categories);

      // Update title checkbox state based on stored data
      updateTitleCheckboxState(categories);

      // Save to local storage
      localStorage.setItem("categoryFilters", JSON.stringify(categories));

      // Add all category IDs to active filters
      // const categoryIds = categories.map((category: any) => category._id);
      setActiveFilters((prev: any) => ({
        ...prev,
        // categories: categoryIds,
        categories: [],
      }));
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchCategories();
  // }, []);

  useEffect(() => {
    const storedCategories = localStorage.getItem("categoryFilters");
    if (storedCategories) {
      const categories = JSON.parse(storedCategories);
      setSelectedFilterData({ categories });
      setFilteredCategories(categories);

      // Update title checkbox state based on stored data
      updateTitleCheckboxState(categories);

      // Update active filters
      // const categoryIds = categories.map((category: any) => category._id);
      // setActiveFilters((prev: any) => ({
      //     ...prev,
      //     categories: categoryIds,
      // }));
      // setLoading(false);

      // Update active filters with only checked categories
      const categoryIds = categories
        .filter((item: any) => item.selected)
        .map((category: any) => category._id);

      setActiveFilters((prev: any) => ({
        ...prev,
        categories: categoryIds,
      }));
      setLoading(false);
    } else {
      fetchCategories({ type: "PAGE_CATEGORY" });
    }
  }, []);

  useEffect(() => {
    // Filter categories based on search input
    const filtered = selectedFilterData.categories.filter((item) =>
      item.label.toLowerCase().includes(search.toLowerCase())
    );
    setFilteredCategories(filtered);
  }, [search, selectedFilterData.categories]);

  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const updatedFilterData = {
      ...selectedFilterData,
      categories: selectedFilterData.categories.map((item, i) =>
        i === index ? { ...item, selected: event.target.checked } : item
      ),
    };
    setSelectedFilterData(updatedFilterData);

    // Update title checkbox state based on stored data
    updateTitleCheckboxState(updatedFilterData.categories);

    // Check if all categories are selected to update Title checkbox
    // const allSelected = updatedFilterData.categories.every(
    //   (item) => item.selected
    // );
    // setIsTitleSelected(allSelected);

    // Save to local storage
    localStorage.setItem(
      "categoryFilters",
      JSON.stringify(updatedFilterData.categories)
    );

    // Call handleChangeActiveFilters with category ID
    // const categoryId = updatedFilterData.categories[index]._id;
    // if (event.target.checked) {
    //   handleChangeActiveFilters("categories", categoryId);
    // } else {
    //   handleChangeActiveFilters("categories", categoryId);
    // }

    // Call handleChangeActiveFilters with category ID
    // const categoryId = updatedFilterData.categories[index]._id;
    // setActiveFilters((prev: any) => {
    //   const updatedCategories = event.target.checked
    //     ? [...prev.categories, categoryId] // Add category ID if checked
    //     : prev.categories.filter((id: string) => id !== categoryId); // Remove category ID if unchecked

    //   return {
    //     ...prev,
    //     categories: updatedCategories,
    //   };
    // });

    // Update active filters based on checked categories
    const categoryIds = updatedFilterData.categories
      .filter((item) => item.selected)
      .map((item) => item._id);
    setActiveFilters((prev: any) => ({
      ...prev,
      categories: categoryIds,
    }));
  };

  // useEffect(() => {
  //   // Check if all categories are selected to update Title checkbox
  //   const allSelected = selectedFilterData.categories.every(
  //     (item) => item.selected
  //   );
  //   setIsTitleSelected(allSelected);
  // }, [selectedFilterData.categories]);

  return (
    <>
      <Box>
        <Box sx={{ display: "flex", height: "52px", m: "24px 20px 12px 20px" }}>
          <Search
            searchFormStyles={{
              minHeight: "22px",
            }}
            style={{
              minHeight: "52px",
              color: "white",
              backgroundColor: "#292929",
              paddingLeft: "47px",
            }}
            icon={true}
            iconStyles={{
              position: "absolute",
              left: "15px",
            }}
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Box>
        <Box
          sx={{
            borderBottom: "1px solid #282828",
            height: "50px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "0px 24px",
            mb: "12px",
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={isTitleSelected}
                onChange={(event) => {
                  const isChecked = event.target.checked;
                  setIsTitleSelected(isChecked);

                  const updatedFilterData = {
                    ...selectedFilterData,
                    categories: selectedFilterData.categories.map((item) => ({
                      ...item,
                      selected: isChecked,
                    })),
                  };
                  setSelectedFilterData(updatedFilterData);

                  // Update activeFilters based on the Title checkbox state
                  const categoryIds = isChecked
                    ? updatedFilterData.categories.map((item) => item._id)
                    : [];
                  setActiveFilters((prev: any) => ({
                    ...prev,
                    categories: categoryIds,
                  }));

                  // Save to local storage
                  localStorage.setItem(
                    "categoryFilters",
                    JSON.stringify(updatedFilterData.categories)
                  );

                  // Update title checkbox state
                  updateTitleCheckboxState(updatedFilterData.categories);
                }}
                sx={{
                  width: "24px",
                  height: "24px",
                  borderRadius: "6px",
                  padding: "4px",
                  border: isTitleSelected ? "" : "1px solid #3D3D3D",
                  "&.MuiCheckbox-root": {
                    color: "#1b1b1b",
                  },
                  "&.Mui-checked": {
                    color: "#CF0",
                    borderRadius: "6px",
                    "& .MuiSvgIcon-root": { fontSize: 28 },
                  },
                }}
              />
            }
            label="Title"
            labelPlacement="start"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              margin: 0,
              padding: 0,
              fontSize: "16px",
              fontWeight: 500,
              color: isTitleSelected ? "#FFFFFF" : "#8D8D8D",
            }}
          />
        </Box>
      </Box>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "75%",
          }}
        >
          <CircularProgress
            size={24}
            sx={{
              color: "white",
            }}
          />
        </Box>
      ) : (
        <Box sx={{ maxHeight: "100vh", marginX: "24px" }}>
          <FormGroup
            sx={{ display: "flex", flexDirection: "column", gap: "4px" }}
          >
            {/* {selectedFilterData.categories.map((item, index) => ( */}
            {filteredCategories.map((item, index) => (
              <>
                <Box
                  key={index}
                  sx={{
                    // borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
                    height: "50px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={item.selected}
                        onChange={(event) => handleCheckboxChange(event, index)}
                        sx={{
                          width: "24px",
                          height: "24px",
                          borderRadius: "6px",
                          padding: "4px",
                          border: item.selected ? "" : "1px solid #3D3D3D",
                          "&.MuiCheckbox-root": {
                            color: "#1b1b1b",
                          },
                          "&.Mui-checked": {
                            color: "#CF0",
                            borderRadius: "6px",
                            "& .MuiSvgIcon-root": { fontSize: 28 },
                          },
                        }}
                      />
                    }
                    label={item.label}
                    labelPlacement="start"
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      margin: 0,
                      padding: 0,
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 400,
                      color: "#FFFFFF",
                    }}
                  />
                </Box>
                {/* {index < selectedFilterData.categories.length - 1 ? ( */}
                {index < filteredCategories.length - 1 ? (
                  <Box
                    sx={{
                      width: "100%",
                      height: "1px",
                      bgcolor: "rgba(255, 255, 255, 0.06)",
                    }}
                  ></Box>
                ) : null}
              </>
            ))}
          </FormGroup>
        </Box>
      )}
    </>
  );
};

export default CategoryFiltersPage;
